import axios from 'axios';
import {http} from "../helper/interceptor";

const {
    REACT_APP_REQUEST_SERVICE,
    REACT_APP_UPLOAD_SERVICE,
    REACT_APP_USER_SERVICE
} = process.env;

export const getCurrentUserDetails = async (userId) => {
    userId = encodeURI(userId);
    return await http.get(`${REACT_APP_USER_SERVICE}/user/${userId}`);
};

export const getUsersByRole = async (role)=>{
    return await http.get(`${REACT_APP_USER_SERVICE}/user/role/${role}`);
}

export const createRequestAccess = async (email) => {
    return await axios.post(`${REACT_APP_USER_SERVICE}/requestAccess`, email);
};

export const getTrnslationRequets = async () => {
    return await http.get(`${REACT_APP_REQUEST_SERVICE}/request`);
};

export const getRevisedPresignUrl = async (obj) => {
    return await http.post(`${REACT_APP_REQUEST_SERVICE}/request/revisescript`, obj);
};

export const getPresignURLOupload = async (obj) => {
    return await http.post(REACT_APP_UPLOAD_SERVICE, obj);
};

export const initiateFileUpload = async (obj) => {
    return await http.post(`${REACT_APP_REQUEST_SERVICE}/upload/uploadRequest`, {...obj})
}

export const getPresignUrls = async (obj) => {
    return await http.post(`${REACT_APP_REQUEST_SERVICE}/upload/uploadUrls`, {...obj});
}

export const finishUploads = async (obj) => {
    return await http.post(`${REACT_APP_REQUEST_SERVICE}/upload/finishUpload`, {...obj});
}

export const uploadUserFile = async (url, formData, cb) => {
    const config = {
        onUploadProgress: progressEvent => {
            const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
            if (totalLength !== null) {
                cb(Math.round((progressEvent.loaded * 100) / totalLength))
            }
        }
    };
    return await axios({
        method: 'post',
        url,
        data: formData,
        config: {
            ...config,
            headers: {'Content-Type': 'multipart/form-data'}
        }
    })
};

export const updateRequest = async (reqData) => {
    return await http.put(`${REACT_APP_REQUEST_SERVICE}/request/${reqData.id}`, reqData);
};

export const checkValidUserSubscription = async (durations, isDocFile) => {
    return await http.post(`${REACT_APP_USER_SERVICE}/subscriptions/limit`,
        {contentLength: durations, isDocFile}
    )
};

export const saveTranslationsRequest = async (reqObj) => {
    return await http.post(`${REACT_APP_REQUEST_SERVICE}/request`, reqObj);
};

export const getSubscriptionPlans = async () => {
    return await http.get(`${REACT_APP_USER_SERVICE}/subscriptions`);
};

export const createPaymentSubsciption = async (obj) => {
    return await http.post(`${REACT_APP_USER_SERVICE}/subscriptions`, {...obj})
};

export const downloadFile = async (fileName, type) => {
    return await http.get(`${REACT_APP_REQUEST_SERVICE}/request/download/${fileName}/${type}`)
};

export const saveFileFromURL = async (url) => {
    return axios({url, method: 'GET', responseType: 'blob'});
};

export const downloadDriveFile = async (fileId) => {
    const accessToken = window.gapi.auth.getToken().access_token;
    return axios({
        url: `https://www.googleapis.com/drive/v3/files/${fileId}/export?mimeType=application/vnd.openxmlformats-officedocument.wordprocessingml.document`,
        method: 'GET',
        responseType: 'blob',
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    })
}

export const getExternalVideoDuration = async (videoId) => {
    return http.post(`${REACT_APP_REQUEST_SERVICE}/upload/externalVideoDuration`, {videoId})
}
